import React from 'react';
import { ArrowRight, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { ctaData } from '../data/mock';

const CTA = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-24 bg-gradient-to-br from-red-600 via-red-700 to-slate-900 text-white relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-0 w-96 h-96 bg-red-400/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-red-500/20 rounded-full blur-3xl animate-pulse delay-1000"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-white text-sm font-medium mb-8">
          <div className="w-2 h-2 bg-red-300 rounded-full animate-pulse"></div>
          Ready to Get Started?
        </div>

        {/* Headline */}
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          {ctaData.headline}
        </h2>

        {/* Description */}
        <p className="text-xl text-red-50 mb-12 max-w-2xl mx-auto leading-relaxed">
          {ctaData.description}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            size="lg"
            onClick={scrollToContact}
            className="bg-white text-red-700 hover:bg-red-50 hover:scale-105 transition-all duration-300 shadow-2xl shadow-red-500/20 px-8 py-6 text-lg font-semibold group"
          >
            {ctaData.cta1}
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Button>
          <Button
            size="lg"
            variant="outline"
            onClick={scrollToContact}
            className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-red-700 hover:scale-105 transition-all duration-300 px-8 py-6 text-lg font-semibold group"
          >
            {ctaData.cta2}
            <Mail className="ml-2 w-5 h-5 group-hover:scale-110 transition-transform" />
          </Button>
        </div>

        {/* Trust Line */}
        <div className="mt-16 flex flex-wrap items-center justify-center gap-6 text-red-100 text-sm">
          <span className="flex items-center gap-2">
            <div className="w-2 h-2 bg-green-400 rounded-full"></div>
            No long-term contracts
          </span>
          <span className="hidden sm:inline">•</span>
          <span className="flex items-center gap-2">
            <div className="w-2 h-2 bg-green-400 rounded-full"></div>
            Free consultation
          </span>
          <span className="hidden sm:inline">•</span>
          <span className="flex items-center gap-2">
            <div className="w-2 h-2 bg-green-400 rounded-full"></div>
            Quick turnaround
          </span>
        </div>
      </div>
    </section>
  );
};

export default CTA;
